import React from 'react'
import styled from '@emotion/styled'
import useInView from 'react-cool-inview'

import ObserverHelperTop from '../utils/observerTop'
import ObserverHelperBottom from '../utils/observerBottom'

import theme from '../utils/theme';


const Project = styled('article')`
  position: relative;
  padding-top: 60px;
  padding-bottom: 160px;

  border-bottom: 1px solid #e6e6e6;

  @media ${theme.breakpoints.md} { 
    padding-top: 120px;
    padding-bottom: 320px;

    /*
    &:first-of-type {
      padding-top: 70px;
    }
    */
  }
`


const ProjectComponent = ({id, title, content, setCurrentProject, isFirst, isLast, setHideStatusContainer, fieldNotes, setFieldNotes, forwardedRef}) => {
    // console.log(title)
  
  
  return (
    <Project 
      ref={forwardedRef}
      id={id}
    >
      <ObserverHelperTop
        title={title}
        id={id}
        setCurrentProject={setCurrentProject}
        isFirst={isFirst}
        setHideStatusContainer={setHideStatusContainer}
        setFieldNotes={setFieldNotes}
        fieldNotes={fieldNotes}
      />
      <div>
        {content}
      </div>
      <ObserverHelperBottom 
        title={title}
        id={id}
        setCurrentProject={setCurrentProject}
        isLast={isLast}
        setHideStatusContainer={setHideStatusContainer}
        setFieldNotes={setFieldNotes}
        fieldNotes={fieldNotes}
      />
    </Project>
  )
}

export default ProjectComponent